import { Outlet } from 'react-router';

function OnboardingLayout() {
  return (
    <>
      <div className="fixed z-0 h-[500px] w-full bg-cover bg-linear-to-t bg-top from-rcprimary-200 to-rcprimary-500" />
      <div className="fixed -right-56 z-1 hidden h-[500px] w-full bg-[url('https://cdn.retainerclub.com/images/defaults/treatment-form.webp')] bg-top-right bg-no-repeat lg:block" />

      <div className="mx-auto max-w-7xl pt-4 xl:mt-4">
        <Outlet />
      </div>
    </>
  );
}

export default OnboardingLayout;
